import React, { FC, useState } from "react";
import CommonLayout from "./CommonLayout";
import Textarea from "shared/Textarea/Textarea";
export interface PageAddListing6Props {
  formik: any;
}

const PageAddListing6: FC<PageAddListing6Props> = ({ formik }) => {
  const handleInputChange = (val: any) => {
    formik.setFieldValue("place_descriptions", val.target.value);
  };

  const handleTogglePropertyHighlights = (option: any) => {
    const currentPropertyHighlights = formik.values.propertyHighlights;
    if (currentPropertyHighlights.includes(option.title)) {
      formik.setFieldValue(
        "propertyHighlights",
        currentPropertyHighlights.filter((item: any) => item !== option.title)
      );
    } else {
      formik.setFieldValue("propertyHighlights", [
        ...currentPropertyHighlights,
        option.title,
      ]);
    }
  };

  const handleToggleTypeOfLocation = (option: string) => {
    const current = formik.values.typeOfLocation;
    // Single-select: toggle off if clicking the same; otherwise set to new option
    if (current === option) {
      formik.setFieldValue("typeOfLocation", "");
    } else {
      formik.setFieldValue("typeOfLocation", option);
    }
  };

  const propertyHighlights = [
    {
      title: "Couple Friendly",
      icon: "/PropHighlights/couple.svg",
    },
    {
      title: "Pet Friendly",
      icon: "/PropHighlights/pet.svg",
    },
    {
      title: "Smoking Allowed",
      icon: "/PropHighlights/cigeratte.svg",
    },
    {
      title: "Party Friendly",
      icon: "/PropHighlights/glasscheers.svg",
    },
    {
      title: "Shoot Friendly",
      icon: "/PropHighlights/camera.svg",
    },
  ];
  const typesOfLocation = [
    "On the beach",
    "In the hills",
    "Downtown",
    "Inside a forest",
    "Riverside",
    "Urban area",
    "Rural area",
    "Near wildlife",
    "On the lake",
  ];
  return (
    <CommonLayout
      index="06"
      backtHref="/add-listing-5"
      nextHref="/add-listing-7"
    >
      <>
        <div>
          <h2 className="text-2xl font-semibold">Property Highlights </h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="space-y-8">
          <div className="flex flex-row flex-wrap ">
            {propertyHighlights.map((option) => (
              <button
                key={option.title}
                type="button"
                onClick={() => handleTogglePropertyHighlights(option)}
                className={`flex items-center justify-center px-4 py-2 border rounded-full text-sm font-medium mt-2 mr-2 ${
                  formik.values.propertyHighlights.includes(option.title)
                    ? "gradient-border"
                    : "bg-white text-gray-700 border-gray-300"
                } hover:bg-gray-100`}
              >
                <span>
                  <img src={option.icon} alt="icon" className="mr-2" />
                </span>
                {option.title}
              </button>
            ))}
          </div>
          {formik.errors && formik.errors.propertyHighlights && (
            <span className="text-red-500 text-sm">
              {formik.errors.propertyHighlights}
            </span>
          )}

          {/* TYPE OF LOCATION */}
          <div>
            <h2 className="text-lg font-semibold">Type Of Location </h2>
            <div className="flex flex-row flex-wrap mt-2 ">
              {typesOfLocation.map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => handleToggleTypeOfLocation(option)}
                  className={`flex items-center justify-center px-4 py-2 border rounded-full text-sm font-medium mt-2 mr-2 ${
                    formik.values.typeOfLocation === option
                      ? "gradient-border"
                      : "bg-white text-gray-700 border-gray-300"
                  } hover:bg-gray-100`}
                >
                  {option}
                </button>
              ))}
            </div>
            {formik.errors && formik.errors.typeOfLocation && (
              <span className="text-red-500 text-sm">
                {formik.errors.typeOfLocation}
              </span>
            )}
          </div>

          {/* PLACE DESCRIPTION */}
          <div>
            <h2 className="text-lg font-semibold">
              Your place description for client
            </h2>
            <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
              Mention the best features of your accommodation, any special
              amenities like fast Wi-Fi or parking, as well as things you like
              about the neighborhood.
            </span>
          </div>
          {formik.errors && formik.errors.place_descriptions && (
            <span className="text-red-500 text-sm">
              {formik.errors.place_descriptions}
            </span>
          )}
          <Textarea
            value={formik.values.place_descriptions}
            handleChange={handleInputChange}
            placeholder="..."
            rows={14}
          />
          <div className=" border-b border-neutral-200 dark:border-neutral-700"></div>
        </div>
      </>
    </CommonLayout>
  );
};

export default PageAddListing6;
